<template>
    <div>
        <ul class="list-group">
            <li class="list-group-item bg-light-secondary" v-for="(war,index) in value" :key="index">{{war}}</li>
        </ul>
    </div>
</template>

<script>
export default {
    props:{
        value:Array
    }
}
</script>

<style>

</style>